import { CAR_MODE, DEFAULT_TRAVEL, govFareOf, type PlayState, type TravelMode } from '@london-life/contracts';
import { useContent } from './content';
import { useGovEffects } from './gov';

// a way to travel as the sheets show it: the content's ways, and "Car" for a player who keeps one (its name,
// its fuel, or the driver on the payroll) — the same list on the place card and the Neighbours sheet; fares as
// the Mayor's policy has them
export type TravelChoice = { mode: TravelMode; label: string; icon: string; farePence: number; note?: string };
export function useTravelChoices(car: PlayState['car'] | undefined): TravelChoice[] {
  const content = useContent();
  // half-price TfL fares while the Mayor's policy is in force (the server charges the same)
  const gov = useGovEffects();
  const choices: TravelChoice[] = (content.catalogue?.travel ?? DEFAULT_TRAVEL)
    .filter((option) => option.visible)
    .map(({ mode, label, icon, farePence }) => ({ mode, label, icon, farePence: govFareOf(mode, farePence, gov) }));
  if (car)
    choices.unshift({
      mode: CAR_MODE,
      label: car.driver ? 'Driver' : car.nick,
      icon: car.driver ? '🧑🏾‍✈️' : car.emoji,
      farePence: car.fuelPence,
      note: car.driver ? `${car.label}, driven` : car.tired ? `${car.label} · needs a service` : car.label,
    });
  return choices;
}
